/*
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { BufferAttribute, ShaderMaterial, Vector4 } from 'three';
import { ChannelType } from '../CrownDesc';
import { CrownShapeCapUtil } from './CrownShapeCapUtil';
import { ShaderAccessor } from './ShaderAccessor';
import { MaterialCache } from '@sick-davinci/glow';
var ChannelTypeKey;
(function (ChannelTypeKey) {
    ChannelTypeKey[ChannelTypeKey["NONE"] = 0] = "NONE";
    ChannelTypeKey[ChannelTypeKey["NO_ECHO"] = 1] = "NO_ECHO";
    ChannelTypeKey[ChannelTypeKey["GLARED"] = 2] = "GLARED";
    ChannelTypeKey[ChannelTypeKey["REFLECTOR"] = 3] = "REFLECTOR";
    ChannelTypeKey[ChannelTypeKey["SENDER_OFF"] = 4] = "SENDER_OFF";
    ChannelTypeKey[ChannelTypeKey["LAST_VALUE"] = 5] = "LAST_VALUE";
})(ChannelTypeKey || (ChannelTypeKey = {}));
/**
 * Updates the shader buffers depending on the labels channel and the setColor function from ScanDecoration
 * DEPRECATED: with AppEngine >2.8 this  Accessor should never be used (Labels was replaces with properties, see ShaderAccessorColorProperties)
 */
export class ShaderAccessorColorFlag extends ShaderAccessor {
    constructor(echoIdx) {
        super(echoIdx);
        this._materialCache = new MaterialCache();
    }
    updateShader(geometry, decoration) {
        if (this._polarScan.LabelValues != null && this._polarScan.LabelValues.length > 0) {
            const labelData = this._polarScan.LabelValues[this._echoIdx];
            let labels;
            if (labelData.numOfElems > 0) {
                const labelsView = CrownShapeCapUtil.getArrayInCorrectByteOrder32(labelData.data, labelData.endian);
                labels = Float32Array.from(new Uint32Array(labelsView.buffer, labelsView.byteOffset, labelsView.byteLength / 4));
            }
            else {
                labels = new Float32Array(this._polarScan.BeamCount);
            }
            geometry.addAttribute('value', new BufferAttribute(labels, 1));
        }
        let factoryCreatedNewMaterial = false;
        this._shaderMaterial = this._materialCache.getMaterial(decoration, () => {
            factoryCreatedNewMaterial = true;
            const uniforms = {
                pointSize: { type: 'f', value: 1 },
                channelTypeColorMap: { type: 'uVec4Array', value: new Array() },
            };
            const COLOR_VALUE_MAP_SIZE = Object.keys(ChannelTypeKey).length / 2;
            for (let i = 0; i < COLOR_VALUE_MAP_SIZE; i++) {
                uniforms.channelTypeColorMap.value[i] = new Vector4();
            }
            return new ShaderMaterial({
                uniforms,
                vertexShader: `
        attribute float phi;
        attribute float theta;
        attribute float dist;
        attribute float value;
        attribute vec4 colors;
        uniform float pointSize;
        varying vec4 vColor;
        uniform vec4 channelTypeColorMap[${COLOR_VALUE_MAP_SIZE}];

        void main() {
          vColor = channelTypeColorMap[int(value)];
          vec4 mvPosition = modelViewMatrix * vec4(cos(theta) * cos(phi) * dist, sin(theta) * cos(phi) * dist, -sin(phi) * dist, 1.0);
          gl_PointSize = pointSize;
          gl_Position = projectionMatrix * mvPosition;
        }`,
                fragmentShader: `
        varying vec4 vColor;
        void main() {
          gl_FragColor = vColor;
        }`,
            });
        });
        // exit if the material was not created. (uniforms are the same!)
        if (!factoryCreatedNewMaterial) {
            return;
        }
        this._shaderMaterial.uniforms.pointSize.value = decoration.PointSize;
        const foundColorsForEcho = this._getColors(decoration);
        // search for the ChannelType.ALL_CHANNELS and fill the channelTypeColorMap
        foundColorsForEcho.some((colorInternal) => {
            if (colorInternal.ChannelType === ChannelType.ALL_CHANNELS) {
                // tslint:disable-next-line:no-any
                this._shaderMaterial.uniforms.channelTypeColorMap.value.forEach((_colorEntry, i) => {
                    this._shaderMaterial.uniforms.channelTypeColorMap.value[i].set(colorInternal.R / 255, colorInternal.G / 255, colorInternal.B / 255, 1);
                });
                return true;
            }
            return false;
        });
        // now search for concrete echo/label mappings for one label there can be
        // currently LABEL is the only supported ChannelType for uni color mapping
        foundColorsForEcho.forEach((colorInternal) => {
            if (colorInternal.ChannelType === ChannelType.LABEL) {
                // if you look at the next weird line read: https://stackoverflow.com/questions/36316326/typescript-ts7015-error-when-accessing-an-enum-using-a-string-type-parameter
                // colorInternal.ChannelTypeKey contains a string representing a value of the ChannelTypeKey enum
                const channelTypeEnumValue = ChannelTypeKey[colorInternal.ChannelTypeKey];
                this._shaderMaterial.uniforms.channelTypeColorMap.value[channelTypeEnumValue].set(colorInternal.R / 255, colorInternal.G / 255, colorInternal.B / 255, 1);
            }
        });
    }
    _getColors(decoration) {
        const _colors = [];
        const colorSettingsForAllEchos = [];
        decoration.Colors.forEach((element) => {
            if (element.ChannelType === 'LABEL' && element.ChannelTypeKey !== '') {
                element.ChannelType = ChannelType.LABEL;
            }
            else {
                element.ChannelType = ChannelType.ALL_CHANNELS;
            }
            if (element.Echo === 0) {
                colorSettingsForAllEchos.push(element);
            }
            if ((element.Echo - 1) !== this._echoIdx) {
                return;
            }
            _colors.push(element);
        });
        return _colors.concat(colorSettingsForAllEchos);
    }
}
//# sourceMappingURL=ShaderAccessorColorFlag.js.map